import React from "react";
import "./Home.scss";

// Components
import HomeCard from "components/Home/HomeCard/HomeCard";
import Heading01 from "components/Headings/Heading01/Heading01";
import Heading02 from "components/Headings/Heading02/Heading02";
import Text from "components/Headings/Text/Text";
import AnimatedLetters from "components/Headings/Common/Utils/Animation/AnimatedLetters";
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";
import Button from "components/UI/Form/Button/Button";

// Libraries & Packages
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      {/* Landing */}
      <div className="home__landing">
        <div className="home__landing__overlay">
          <div className="home__landing__overlay__name">
            <AnimatedText delay={2}>Naveen Liyanage</AnimatedText>
          </div>
          <div className="home__landing__overlay__phrase">
            <AnimatedText delay={3}>Designer & Developer</AnimatedText>
          </div>
        </div>
      </div>
      {/* Services */}
      <div className="home__section">
        {/* Services - Details */}
        <div className="home__section__details">
          <Heading01>
            <AnimatedLetters text="Services" />
          </Heading01>
          <Heading02>
            <AnimatedText delay={0.5}>
              "Innovative Designs, Seamless Development - Your Digital Solutions
              Provider."
            </AnimatedText>
          </Heading02>
          <div className="home__section__details__text">
            <Text>
              <AnimatedText delay={0.75}>
                Welcome to a realm where creativity meets precision. As your
                dedicated digital solutions provider, I specialize in crafting
                innovative designs and ensuring seamless development. Whether
                you're looking for a visually striking website, a user-friendly
                app, or a complete digital overhaul, I bring a blend of
                creativity and technical expertise to the table. With a focus on
                innovation and a commitment to flawless execution, I'm here to
                turn your digital aspirations into reality.
              </AnimatedText>
            </Text>
          </div>
        </div>
        {/* Services - Grid */}
        <div className="home__section__grid">
          <HomeCard title="Logo Design" />
          <HomeCard title="UI/UX Design" />
          <HomeCard title="Web Development" />
          <HomeCard title="Graphic Design" />
          <HomeCard title="Motion Design" />
          <HomeCard title="3D Modelling" />
        </div>
      </div>
      {/* Contact Me */}
      <div className="home__section">
        <div className="home__section__details">
          <Heading01>
            <AnimatedLetters text="Contact Me" />
          </Heading01>
          <Heading02>
            <AnimatedText delay={0.5}>
              "Your Vision, My Expertise - Reach Out and Let's Create Something
              Extraordinary."
            </AnimatedText>
          </Heading02>
          <div className="home__section__details__text">
            <Text>
              <AnimatedText delay={0.75}>
                Embark on a creative journey where your unique vision meets the
                expertise to bring it to life. As a designer and web developer,
                I am committed to transforming your ideas into extraordinary
                digital experiences. From concept to execution, let's
                collaborate closely to craft a tailored solution that not only
                meets but exceeds your expectations. Your vision is the
                inspiration, and my skills are the tools to turn it into a
                digital masterpiece. Contact me today, and let's begin the
                exciting process of creating something truly extraordinary for
                your brand or project.
              </AnimatedText>
            </Text>
          </div>
        </div>
        <div className="home__section__button">
          <AnimatedText>
            <Link to={"/contact-me"} style={{ textDecoration: "none" }}>
              <Button>CONTACT ME</Button>
            </Link>
          </AnimatedText>
        </div>
      </div>
    </div>
  );
}

export default Home;
